export const apiFetch = (url, options = {}) => {
  return fetch(url, {
    ...options,
    credentials: 'include', // 🔥 REQUIRED
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  }).then(res => res.json());
};

export const downloadPdf = async (url) => {
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'Accept': 'application/pdf',
    },
  });

  if (!response.ok) {
    // Try to parse error as JSON, fallback to text
    let errorMessage = 'Download failed';
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch {
      const errorText = await response.text();
      errorMessage = errorText || errorMessage;
    }
    throw new Error(errorMessage);
  }

  // Check if response is actually a PDF
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/pdf')) {
    throw new Error('Invalid response format - expected PDF');
  }

  return response.blob();
};